import React from "react";
import {
  Hammer,
  Wrench,
  Plug,
  Droplets,
  PaintRoller,
  Trees,
  KeyRound,
  Sparkles,
} from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Hammer, Wrench, Plug, Droplets, PaintRoller, Trees, KeyRound, Sparkles];

export function Services() {
  const { t } = useLanguage();
  const items = t("services.items");

  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-terracotta">
            {t("services.eyebrow")}
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-ink leading-tight">
            {t("services.title")}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-brand-ink/70 leading-relaxed">
            {t("services.subtitle")}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {Array.isArray(items) &&
            items.map((it, idx) => {
              const Icon = ICONS[idx % ICONS.length];
              const featured = idx === 0 || idx === 6;
              return (
                <div
                  key={idx}
                  data-testid={`service-card-${idx}`}
                  className={`group relative rounded-2xl border p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                    featured
                      ? "bg-brand-aegean text-white border-brand-aegean lg:col-span-2"
                      : "bg-white border-brand-sand hover:border-brand-terracotta/50"
                  }`}
                >
                  <div
                    className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${
                      featured
                        ? "bg-white/10 text-white"
                        : "bg-brand-terracotta/10 text-brand-terracotta"
                    }`}
                  >
                    <Icon size={20} />
                  </div>
                  <h3
                    className={`mt-5 font-display text-xl font-semibold ${
                      featured ? "text-white" : "text-brand-ink"
                    }`}
                  >
                    {it.title}
                  </h3>
                  <p
                    className={`mt-2 text-sm leading-relaxed ${
                      featured ? "text-white/80" : "text-brand-ink/70"
                    }`}
                  >
                    {it.desc}
                  </p>
                  <div
                    className={`mt-6 h-px w-8 ${
                      featured ? "bg-white/40" : "bg-brand-terracotta/40"
                    } group-hover:w-16 transition-all`}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
